import PopoverContainer from '@/common/components/popover-container';
import Spacer from '@/common/components/spacer';
import HelpSmall from '@/icons/help-small';
import { colors } from '@/theme/colors';

interface SavingsReceiptTitleWithTooltipProps {
  title: string;
  tooltipTitle?: string;
  tooltipDescription: string;
}

export default function SavingsReceiptTitleWithTooltip({
  title,
  tooltipTitle,
  tooltipDescription,
}: SavingsReceiptTitleWithTooltipProps) {
  const contents = (
    <div className="flex max-w-[240px] flex-col items-center justify-center p-[16px]">
      {tooltipTitle ? (
        <>
          <p className="body2-strong text-center">{tooltipTitle}</p>
          <Spacer variant="height8" />
        </>
      ) : null}
      <p className="body2 text-left">{tooltipDescription}</p>
    </div>
  );

  const trigger = <HelpSmall fill={colors.neutral60} className="h-[16px] w-[16px]" />;

  return (
    <div className="flex flex-row items-center gap-[4px]">
      <p className="body-strong">{title}</p>
      <PopoverContainer
        triggerComponent={trigger}
        contents={contents}
        hasArrow={false}
        contentAlign="center"
        contentSide="bottom"
        className="p-0"
      />
    </div>
  );
}
